// extracted by mini-css-extract-plugin
export var border = "SponsorDogPromoCardFlat-module--border--d4857";
export var bordercontainer = "SponsorDogPromoCardFlat-module--bordercontainer--80715";
export var bottomheart = "SponsorDogPromoCardFlat-module--bottomheart--ef936";
export var buttonwrapper = "SponsorDogPromoCardFlat-module--buttonwrapper--c26f8";
export var details = "SponsorDogPromoCardFlat-module--details--7508c";
export var image = "SponsorDogPromoCardFlat-module--image--cfda4";
export var label = "SponsorDogPromoCardFlat-module--label--ccb7c";
export var labeltext = "SponsorDogPromoCardFlat-module--labeltext--8048f";
export var sponsordogpromocontainer = "SponsorDogPromoCardFlat-module--sponsordogpromocontainer--d02ad";
export var text = "SponsorDogPromoCardFlat-module--text--4cc37";
export var topheart = "SponsorDogPromoCardFlat-module--topheart--f6551";